// src/firebase.js
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth,setPersistence, browserSessionPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAMh9rpF80aALyAl9L7Ib4GPhgHlHOeI14",
  authDomain: "shareasecret-7d042.firebaseapp.com",
  projectId: "shareasecret-7d042",
  storageBucket: "shareasecret-7d042.firebasestorage.app",
  messagingSenderId: "34714192744",
  appId: "1:34714192744:web:13b23fed00571fb162e4dd",
  measurementId: "G-CTM1BMWCY5"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

//connectFunctionsEmulator(functions, "localhost", 5001)
setPersistence(auth, browserSessionPersistence)
//connectAuthEmulator(auth, 'http://localhost:9099');

export { storage, db, auth, functions };